import React, { Component } from 'react';
import { HashRouter, BrowserRouter, Route, Switch } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { hotjar } from 'react-hotjar';

//import { FetchData } from './components/FetchData';
//import AuthorizeRoute from './containers/AuthorizeRoute';
import './scss/style.scss';
import 'react-toastify/dist/ReactToastify.css';

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./components/login/Login'));
const SignUp = React.lazy(() => import('./components/login/SignUp'));
const Benefits = React.lazy(() => import('./components/login/benefits'));
const ChangePassword = React.lazy(() => import('./components/login/ChangePassword'));
const EmailVerification = React.lazy(() => import('./components/login/EmailVerification'));
const Unsubscribe = React.lazy(() => import('./components/unsubscribe/unsubscribe'));


hotjar.initialize(2611501, 6);
const loading = (
    <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
)


export default class App extends Component {
    static displayName = App.name;


    render() {


        return (
            <BrowserRouter>

            <Switch>
              <HashRouter exact path="/">
                  <React.Suspense fallback={loading}>
                      <Switch>
                            <Route exact path="/unsubscribe/:unsubKey" name="Unsubscribe" render={props => <Unsubscribe {...props}/>} />
                            <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />
                            <Route exact path="/signup" name="Sign Up" render={props => <SignUp {...props} />} />
                            <Route exact path="/benefits" name="Benefits" render={props => <Benefits {...props} />} />
                            <Route exact path="/EmailVerification/:status?" name="EmailVerification" render={props => <EmailVerification {...props} />} />
                            {/*<AuthorizeRoute exact path='/fetch-data' component={props => <TheLayout {...props}/>} />*/}
                            <Route path="/" name="Home" component={props => <TheLayout {...props} />} />
                            <Route path="/changePassword" name="ChangePassword" render={props => <ChangePassword{...props} />} />
                      </Switch>
                  </React.Suspense>
              </HashRouter>
            </Switch>
                <ToastContainer />
          </BrowserRouter>

        );
    }
}
